export const EmploymentAndIncomeTestIds = {
  ADD_EMPLOYMENT_VERIFICATION_BUTTON: 'employment-income.add-employment-verification-button',
  ADD_FUNDING_VERIFICATION_BUTTON: 'employment-income.add-funding-verification-button',
  VERIFICATION_FORM_CANCEL_BUTTON: 'employment-verification-form.cancel-button',
  VERIFICATION_FORM_ADD_BUTTON: 'employment-verification-form.add-button',
};
